 export const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  
  export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  export const decryptString = (encryptedString) => {
    const padded = encryptedString
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(encryptedString.length + (4 - encryptedString.length % 4) % 4, '=');

  const binaryStr = atob(padded);
  const byteArray = Uint8Array.from(binaryStr, c => (c.charCodeAt(0) - 3 + 256) % 256);

  const json = new TextDecoder().decode(byteArray);
  return JSON.parse(json);
  };

  export const encryptString = (obj) => {
    const json = JSON.stringify(obj);
    const utf8Bytes = new TextEncoder().encode(json); // convert to UTF-8 bytes
  
    const shiftedBytes = utf8Bytes.map(b => (b + 3) % 256);
    const binaryStr = String.fromCharCode(...shiftedBytes);
  
    const base64 = btoa(binaryStr)
      .replace(/\+/g, '-') // URL-safe Base64
      .replace(/\//g, '_')
      .replace(/=+$/, ''); // remove padding
  
    return base64;
  };

  
  